/** T86 — Print-templates client. */
import { apiClient } from "./client";

export type PaperSize = "A4" | "A5";

/** One per document type. The shape is owned by the FE; the BE round-trips JSON opaquely. */
export interface PrintDocTemplate {
  paperSize: PaperSize;
  /** Big bold title above the table (VD: "ĐƠN THUỐC", "HOÁ ĐƠN", "BIÊN LAI THU TIỀN"). */
  headerTitle: string;
  /** Optional subtitle line right under the title. */
  headerSubtitle: string;
  /** Footer line printed at the very bottom (VD: "Cảm ơn quý khách"). */
  footerText: string;
  /** Label above the signature line ("Bác sĩ ký tên", "Người thu tiền", …). */
  signatureLabel: string;
  /** Whether to render the clinic header block (name/address/phone) above the title. */
  showClinicHeader: boolean;
}

export interface PrintTemplatesPayload {
  prescription: PrintDocTemplate;
  invoice: PrintDocTemplate;
  receipt: PrintDocTemplate;
}

export const DOC_TYPES = [
  { key: "prescription", label: "Đơn thuốc" },
  { key: "invoice", label: "Hoá đơn" },
  { key: "receipt", label: "Biên lai" },
] as const;
export type DocTypeKey = (typeof DOC_TYPES)[number]["key"];

export const PAPER_SIZES: { value: PaperSize; label: string }[] = [
  { value: "A5", label: "A5 (148 × 210 mm) — đơn nhỏ, in nhanh" },
  { value: "A4", label: "A4 (210 × 297 mm) — đầy đủ" },
];

export const printTemplatesApi = {
  get(): Promise<PrintTemplatesPayload> {
    return apiClient
      .get<PrintTemplatesPayload>("/v1/clinic/print-templates")
      .then((r) => r.data);
  },
  update(payload: PrintTemplatesPayload): Promise<PrintTemplatesPayload> {
    return apiClient
      .put<PrintTemplatesPayload>("/v1/clinic/print-templates", payload)
      .then((r) => r.data);
  },
};

export const printTemplatesQueryKeys = {
  all: () => ["print-templates"] as const,
};
